import { useDispatch, useSelector } from "react-redux";
import { downloadMemberContractsExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useMemberContractsExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.memberContracts.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadMemberContractsExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
